import { call, take, takeEvery } from 'redux-saga/effects';
import {
  DELETE_SELECTED_SCENES,
  UPDATE_SCRIBE,
  CREATE_SCENE,
  DUPLICATE_SELECTED_SCENES
} from 'JS/actionCreators/scribeActions';

import { track } from '../mixpanelProvider';

function* trackDeleteSelectedScenes({ scribeId, eventTrigger }) {
  const { scribe: updatedScribe } = yield take(UPDATE_SCRIBE);
  yield call(track, 'Delete Scene', {
    'Scribe ID': scribeId,
    'Number of Scenes': updatedScribe.scenes.length,
    'Event Trigger': eventTrigger
  });
}

function* trackAddScene({ scribeId, eventTrigger }) {
  const { scribe: updatedScribe } = yield take(UPDATE_SCRIBE);
  yield call(track, 'Add Scene', {
    'Scribe ID': scribeId,
    'Number of Scenes': updatedScribe.scenes.length,
    'Event Trigger': eventTrigger
  });
}

function* trackDuplicateScene({ scribeId, eventTrigger }) {
  const { scribe: updatedScribe } = yield take(UPDATE_SCRIBE);
  yield call(track, 'Duplicate Scene', {
    'Scribe ID': scribeId,
    'Number of Scenes': updatedScribe.scenes.length,
    'Event Trigger': eventTrigger
  });
}

export default function* trackScenesSagas() {
  yield takeEvery(DELETE_SELECTED_SCENES, trackDeleteSelectedScenes);
  yield takeEvery(CREATE_SCENE, trackAddScene);
  yield takeEvery(DUPLICATE_SELECTED_SCENES, trackDuplicateScene);
}
